module.exports = __webpack_public_path__ + "img/avatar0.cc3c618e.png";